import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import "./style.css";
import Swal from "sweetalert2";
import {
  AddEvaluatorInfo,
  GetEvaluatorInfoRowByUserId,
} from "../../../Redux/Reducers/Manager/EvaluatorInfo";
import { GetAllFieldsManager } from "../../../Redux/Reducers/Manager/Dropdowns/GetAllFieldsManager";
import { GetAllRoundActive } from "../../../Redux/Reducers/Manager/Dropdowns/GetAllRoundActive";
import { GetAllSubjectManager } from "../../../Redux/Reducers/Manager/Dropdowns/GetAllSubjectManager";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import TextAreaAHSF from "../../../Components/TextAreaAHSF";
import InputAHSF from "../../../Components/InputAHSF";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import AttachmentASFH from "../../../Components/AttachmentsAHSF";
import EvaluatorTable from "./EvaluatorTable";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
const SetEvaluatorForm = () => {
  const dispatch = useDispatch();
  const { userId } = useParams();

  const [DropDownRoundActive, setDropDownRoundActive] = useState(null);
  const [DropDownFields, setDropDownFields] = useState(null);
  const [DropDownSubject, setDropDownSubject] = useState(null);
  const [Note, setNote] = useState("");
  const [
    EvaluatorAppointmentLetterAttachedPath,
    setEvaluatorAppointmentLetterAttachedPath,
  ] = useState(null);
  const [
    EvaluatorAppointmentLetterAttachedFile,
    setEvaluatorAppointmentLetterAttachedFile,
  ] = useState(null);
  const EvaluatorInfoRow = useSelector(
    (state) => state.EvaluatorInfo?.EvaluatorInfoRow
  );

  const { AllRoundActive, AllFieldsManager, AllSubjectManager } = useSelector(
    (state) => ({
      AllRoundActive: state.AllRoundActive.AllRoundActive,
      AllFieldsManager: state.AllFieldsManager.AllFieldsManager,
      AllSubjectManager: state.AllSubjectManager.AllSubjectManager,
    })
  );
  console.log("gggggggggggggggggggg");

  useEffect(() => {
    if (userId) {
      dispatch(GetEvaluatorInfoRowByUserId({ uS_UserGuid: userId }));
    }
  }, [userId, dispatch]);

  useEffect(() => {
    dispatch(GetAllRoundActive());
  }, [dispatch]);

  useEffect(() => {
    if (DropDownRoundActive) {
      dispatch(
        GetAllFieldsManager({ roundYearId: parseInt(DropDownRoundActive) })
      );
    }
  }, [DropDownRoundActive, dispatch]);

  useEffect(() => {
    if (DropDownFields) {
      dispatch(GetAllSubjectManager({ fieldId: DropDownFields }));
    }
  }, [DropDownFields, dispatch]);

  const handleAddEvaluatorInfo = async () => {
    const missingFields = [];

    if (!DropDownRoundActive) missingFields.push("الدورة");
    if (!DropDownFields) missingFields.push("الحقل");
    if (!DropDownSubject) missingFields.push("الموضوع");
    if (!EvaluatorAppointmentLetterAttachedFile)
      missingFields.push("مرفق كتاب تعيين المحكم");

    if (missingFields.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "الرجاء تعبئة الحقول التالية",
        html: `
          <div style="text-align: right; direction: rtl; font-size: 16px;">
            <ul style="list-style-type: none; padding: 0;">
              ${missingFields
                .map(
                  (field) =>
                    `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
                )
                .join("")}
            </ul>
          </div>
        `,
        confirmButtonText: "حسناً",
      });
      return;
    }

    try {
      const formData = new FormData();
      formData.append("UserId", userId);
      formData.append("FieldId", DropDownFields);
      formData.append("RoundId", DropDownRoundActive);
      formData.append("SubjectId", DropDownSubject);
      formData.append("Note", Note);
      formData.append(
        "EvaluatorAppointmentLetterAttached",
        EvaluatorAppointmentLetterAttachedPath
      );
      if (EvaluatorAppointmentLetterAttachedFile) {
        formData.append("file", EvaluatorAppointmentLetterAttachedFile);
      }

      const result = await dispatch(AddEvaluatorInfo(formData));
      console.log(result, "resultresult");

      if (result?.payload?.code === 200) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "تم حفظ المعلومات بنجاح",
          showConfirmButton: false,
          timer: 1500,
        });

        setDropDownRoundActive(null);
        setDropDownFields(null);
        setDropDownSubject(null);
        setNote("");
        setEvaluatorAppointmentLetterAttachedFile(null);
        setEvaluatorAppointmentLetterAttachedPath(null);
      } else if (
        result?.payload?.message ===
        "لا يمكن تكرار نفس الحقل و الموضوع لنفس الدورة"
      ) {
        Swal.fire({
          icon: "error",
          title: "تنبيه",
          text: result.payload.message,
          confirmButtonText: "حسناً",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "حدث خطأ",
          text: result?.payload?.message || "يرجى المحاولة لاحقاً",
          confirmButtonText: "حسناً",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "خطأ",
        text: error?.message || "حدث خطأ غير متوقع",
        confirmButtonText: "حسناً",
      });
    }
    dispatch(setRefreshTable({ tableId: "EvaluatorInfo" }));
  };
  console.log(Note, "Note");

  return (
    <>
      {EvaluatorInfoRow ? (
        <SharedDiv
          showTitle={true}
          titleNameAR="معلومات عضو التقييم"
          child={[
            <div className="containerSetEvaluterForm">
              <div className="containerSetEvaluterFormChild">
                <div className="form-grid">
                  <InputAHSF
                    fieldsName="EvaluatorName"
                    show={true}
                    disabled={true}
                    defaultValue={EvaluatorInfoRow?.evaluatorName}
                  />

                  <InputAHSF
                    fieldsName="EvaluatorEmail"
                    show={true}
                    disabled={true}
                    defaultValue={EvaluatorInfoRow?.email}
                  />
                  <div style={{ marginTop:"-2px" }}>
                    <AllDropDownsAHSF
                      fieldsName="Round"
                      show={true}
                      id="round"
                      lang="ar"
                      arrayOoptionList={AllRoundActive}
                      KeyText={"roundNameAr"}
                      KeyValue={"roundYearId"}
                      dropdownType={"normal"}
                      onChange={(e) => {
                        setDropDownRoundActive(e.target.value);
                      }}
                      defaultValue={DropDownRoundActive}
                    />
                  </div>
                  <AllDropDownsAHSF
                    fieldsName="field"
                    lang="ar"
                    show={true}
                    arrayOoptionList={AllFieldsManager}
                    KeyText={"fieldNameAr"}
                    KeyValue={"fieldId"}
                    dropdownType={"normal"}
                    onChange={(e) => {
                      setDropDownFields(e.target.value);
                    }}
                    defaultValue={DropDownFields}
                  />
                  <AllDropDownsAHSF
                    fieldsName="topic"
                    lang="ar"
                    show={true}
                    arrayOoptionList={AllSubjectManager}
                    KeyText={"subjectNameAr"}
                    KeyValue={"subjectId"}
                    dropdownType={"normal"}
                    onChange={(e) => {
                      setDropDownSubject(e.target.value);
                    }}
                    defaultValue={DropDownSubject}
                  />
                  <div style={{ marginTop: "20px" }}>
                    <AttachmentASFH
                      show={true}
                      clear={false}
                      AttachementType="EvaluatorAppointmentLetterAttached"
                      readOnly={false}
                      singleFile={EvaluatorAppointmentLetterAttachedFile}
                      onChange={(e) => {
                        console.log(e.target.files[0]);
                        setEvaluatorAppointmentLetterAttachedFile(
                          e.target.files[0]
                        );
                      }}
                      fieldsName="EvaluatorAppointmentLetterAttached"
                      title="المرفقات"
                      id="file-1"
                      text="انقر للإضافة مرفق"
                    />
                  </div>
                  <TextAreaAHSF
                    fieldsName="Note"
                    show={true}
                    onChange={(e) => {
                      setNote(e.target.value);
                    }}
                    value={Note}
                  />
                </div>
              </div>
            </div>,

            <EvaluatorTable />,
            <div className="containerButtonMAin">
              <ButtonAHSF
                onClick={handleAddEvaluatorInfo}
                fieldsName="Assign"
                lang={"ar"}
                title={"تعيين"}
                text={"تعيين"}
                show={true}
              />
            </div>,
          ]}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default SetEvaluatorForm;
